export default "__VITE_ASSET__B378n7NN__"